import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalProvider } from '../../providers/global/global';
import { TimesheetType3Page } from '../timesheet-type3/timesheet-type3';
import { ExpensesPage } from '../expenses/expenses';
import { ConfirmType1Page } from '../../pages/confirm-type1/confirm-type1';
import { ConfirmType1MonthlyPage } from '../../pages/confirm-type1-monthly/confirm-type1-monthly';
import { RequestsProvider } from '../../providers/requests/requests';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';

/**
 * Generated class for the Tab2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tab2',
  templateUrl: 'tab2.html',
})
export class Tab2Page {

  //local: string;
  caption: Array<string>;
  id: string;
  res1: any;
  res2: any;
  dttab2: Array<string>;
  dt1:any;
  dt2: any;
  quantity6: string;
  quantity7: string;
  g0: string;
  tabIndex: number;
  totaltimearray: Array<string>;

  constructor(public global: GlobalProvider,public http: HttpClient, public navCtrl: NavController,
    public navParams: NavParams ,public requests:RequestsProvider, public popoverCtrl: PopoverController ) {

      // this.local = localStorage.getItem('Auth');
      // debugger

      this.caption = this.global.TAB2Caption;
      this.totaltimearray = this.global.TAB2TotalTime;
      //console.log(this.caption);
      //console.log(this.global.TAB2id);

      this.global.ndays = this.global.TAB2id.length - 2;

      // var reload = this.navParams.get('reload');
      // if(reload == 1){
      //   this.httpRequestTab2();
      // }


  }

  httpRequestTab2(){

    // this.global.createLoader();
    // this.global.loading.present().then((result) => {


    //this.flag = true;
        //debugger;
        var p:any={};
        p.timesheetid = this.global.timesheetid;
        p.timesheettype = this.global.timesheettype;
        p.contacttype = this.global.contacttype;
        p.id = this.global.id;
        p.entity = 'TAB2';

        const params = new HttpParams()
        .set('j',JSON.stringify(p))


        this.http.post('timesheets/timesheet_read/',params).subscribe(
          (data) => {
            //this.flag = false;

            this.res2 = data;
            var r = JSON.parse(this.res2.dt)
          
            if(this.res2.result == true){
              
              var dt2 = JSON.parse(this.res2.dt);
              this.global.dt2 = JSON.parse(dt2[0]);
              //console.log('len: ' + this.global.dt2.length);

              this.global.TAB2Caption=[];
              this.global.TAB2id = [];
              this.global.TAB2TotalTime=[];
              for(var i = 0; i < this.global.dt2.length; i++){
                // debugger
                this.global.TAB2Caption[i] = this.global.dt2[i]['Caption'];
                this.global.TAB2id[i] = this.global.dt2[i]['ID'];
                this.global.TAB2TotalTime[i] = this.global.dt2[i]['TotalTime'];
                
              }

              this.caption = this.global.TAB2Caption;
              this.totaltimearray = this.global.TAB2TotalTime;
              //console.log(this.caption);

              //console.log(this.global.TAB2id);
              this.global.ndays = this.global.TAB2id.length - 2;

          }
          else{
            // this.global.loading.dismiss();
            //this.httpRequestGrid1_read();
          }


          },
          error => {alert('error');}
        );

    }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }
  tab2Click(i:number){
    this.global.tab2index = i;
    this.global.ndaysIndex = 1;
    this.id = this.global.TAB2id[i];
    //debugger
    if (this.id.trim() == "EXPENSES2" ) {
      this.httpRequestExpenses_read();

    } else if (this.id.trim() == "TOTALS2" || this.id.trim() == "TAB2T"){

      
      if(this.global.TimesheetPeriod == 1 ){
        if(this.requests.MonthlyTotalsReceived.observers.length==0){
          this.requests.MonthlyTotalsReceived.subscribe(
            () => {
              // debugger
              //console.log('Monthly Total Data Received.......... : ' );
              this.navCtrl.push(ConfirmType1MonthlyPage);
            }
          );
        }
        this.requests.httpRequest_totalmonthly();
      }
      else {
        if(this.requests.TotalsReceived.observers.length==0){
          this.requests.TotalsReceived.subscribe(
            () => {
              // debugger
              //console.log('Total Data Received.......... : ' );
              this.navCtrl.push(ConfirmType1Page);
            }
          );
        }
        this.requests.httpRequest_totalgrid1();

      }
      


    }
    else {
      this.httpRequestGrid1_read();
    }
  }
  
  httpRequestExpenses_read(){
    
    this.global.createLoader();
    this.global.loading.present().then((result) => {

      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.contacttype = this.global.contacttype;
      p.timesheetentriesid = '0';
      p.userid = '0';

      const params = new HttpParams()
      .set('j',JSON.stringify(p))


      this.http.post('timesheets/expenses_read/',params).subscribe(

        (data) => {
          //debugger

          this.global.loading.dismiss();
          var resexpenses: any = data;
          if (resexpenses.result == true) {
            this.global.dt_expenses = JSON.parse(resexpenses.dt);
            this.httpRequestExpenses_ddl_read();
            
          }
          
        },
        error => {
          alert('error');
        }
      );

    }).catch((err) => {

    });


  }

  httpRequestExpenses_ddl_read(){
    //this.global.createLoader();
    //this.global.loading.present().then((result) => {

    var p:any = {};
    //p.sp_name = "sp_expense_types_ddl";
    p.timesheetid = this.global.timesheetid;
    p.timesheetentriesid = '0';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/expenses_ddl_read/',params).subscribe(

      (data) => {
        //debugger

        //this.global.loading.dismiss();
        var resexpenses_ddl : any = data;
        if (resexpenses_ddl.result == true) {
          //debugger
          this.global.dt_expenses_ddl = JSON.parse(resexpenses_ddl.dt);
          this.navCtrl.push(ExpensesPage);
        }
        
      },
      error => {
        alert('error');
      }
    );

  // }).catch((err) => {

  // });

  }

  httpRequestGrid1_read(){

    this.global.createLoader();
    this.global.loading.present().then((result) => {

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = this.id;
    p.entity = 'GRID1';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {

        this.global.loading.dismiss();
        //debugger
        this.res1 = data;
        if (this.res1.result == true) {

          this.global.dt_grid1 = JSON.parse(this.res1.dt);
          this.global.grid1Visibility = true;
          this.httpRequestGrid2_read();

        }
        else {
          this.global.grid1Visibility=false;
          this.httpRequestGrid2_read();
        }
      },
      error => {
        alert('error');
      }
    );

  }).catch((err) => {

  });


  }

  httpRequestGrid2_read(){

    var p:any={};
    p.timesheetid = this.global.timesheetid;
    p.timesheettype = this.global.timesheettype;
    p.contacttype = this.global.contacttype;
    p.id = this.id;
    p.entity = 'GRID2';

    const params = new HttpParams()
    .set('j',JSON.stringify(p))


    this.http.post('timesheets/timesheet_read/',params).subscribe(

      (data) => {
        // this.global.loading.dismiss();

        //debugger;
        this.res2 = data;
        if(this.res2.result == true)
        {
          //debugger;
          //console.log('2: ' + this.res2);
          this.global.dt_grid2 = JSON.parse(this.res2.dt);
          this.global.dt2table1 = JSON.parse(this.global.dt_grid2[0]);
          this.global.grid2Visibility = true;

          this.global.setGrid2Option();
                    // this.global.shownGroup=0;
          this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.id});
          
          //console.log('dt1:' + this.dt1);
          //console.log('dt2:' + this.dt2);

        }
        else {
          this.global.grid2Visibility = false;
          // this.global.shownGroup=0;
          this.navCtrl.push(TimesheetType3Page, {TAB2ID: this.id});
        }


      },
      error => {
        alert('error');
      }
    );

  // }).catch((err) => {

  // });


  }



  ionViewDidLoad() {
    console.log('ionViewDidLoad Tab2Page');
  }


}



// WEBPACK FOOTER //
// ./src/pages/tab2/tab2.ts